import React, { FC } from "react";
import { Button, Link } from "gatsby-theme-material-ui";
import {
  KeyboardArrowRightRounded,
  OpenInNewRounded,
} from "@mui/icons-material";
import { SxProps } from "@mui/material";
import { docsURL } from "@src/urls";

interface Props {
  variant?: "outlined" | "contained" | "text";
  subpath?: string;
  label?: string;
  icon?: "open" | "arrow";
  buttonSx?: SxProps;
}

const DocsButton: FC<Props> = ({
  variant = "outlined",
  subpath = "",
  label = "Learn how it works",
  icon = "open",
  buttonSx,
}) => {
  const url = `${docsURL}${subpath}`;
  const endIcon =
    icon === "open" ? (
      <OpenInNewRounded fontSize="small" />
    ) : (
      <KeyboardArrowRightRounded fontSize="small" />
    );
  const buttonColor = variant === "text" ? "primary" : "secondary";

  return (
    <Link href={url} target="_new" underline="none">
      <Button
        variant={variant}
        color={buttonColor}
        disableRipple
        disableElevation
        fullWidth
        endIcon={endIcon}
        sx={buttonSx}
      >
        {label}
      </Button>
    </Link>
  );
};

export default DocsButton;
